// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"09d7c2e6","453":"ef4eb1b9","455":"54533b9b","977":"31926572"}[chunkId] + ".chunk.js";
};